import React from "react";
import "../Footer.css";
import { track } from "../../../services/analytics";

interface AppDownloadsProps {
  appStoreUrl: string;
  playStoreUrl: string;
}

const AppDownloads: React.FC<AppDownloadsProps> = ({ appStoreUrl, playStoreUrl }) => {
  const trackAppDownload = (identificador: string) => {
    track("link_externo_clique", {
      identificador,
      categoria: "produto_forluz",
    });
  };

  return (
    <div className="footer-app-downloads">
      <div className="footer-app-links">
        <a
          href={appStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-app-link"
          onClick={() => trackAppDownload("app_store")}
        >
          <img
            src={require("../../../assets/img/apple.svg").default}
            alt="App Store"
            className="footer-app-icon"
          />
        </a>
        <a
          href={playStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-app-link"
          onClick={() => trackAppDownload("google_play")}
        >
          <img
            src={require("../../../assets/img/googlePB.svg").default}
            alt="Google Play"
            className="footer-app-icon"
          />
        </a>
      </div>
    </div>
  );
};

export default AppDownloads;
